import { instance } from "./axios";

export const request = (
  method: string,
  url: string,
  payload: any = null,
  headers: any = null
) => {
  const requestData: any = { method, url };
  const token = localStorage.getItem("token");
  const isPublicProductRoute =
    url.startsWith("/product/getCategoryList") ||
    url.startsWith("/product/getProductList") ||
    url.startsWith("/product/getProductReview") ||
    url.startsWith("/product/getShippingCostOnPin");
  if (payload) requestData.data = payload;
  requestData.headers = {
    Accept: "*/*",
  };
  if (headers) requestData.headers = { ...requestData.headers, ...headers };
  if (token && !isPublicProductRoute)
    requestData.headers = {
      ...requestData.headers,
      Authorization: "Bearer " + token,
    };
  return instance(requestData);
};
